module.exports = __webpack_public_path__ + "static/media/photo2.38f366c0.jpg";